import React, { useState, useEffect, useRef } from 'react';
import './style.css';

import AboutUsCover from '../../assets/images/AboutUsCover.webp';

import { IoMdPlay } from 'react-icons/io';

export default function AboutUsSection() {
  const [isPlaying, setIsPlaying] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentSectionRef = sectionRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // Start playing the video when the section is in view
          setIsPlaying(true);
        } else {
          setIsPlaying(false);
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (currentSectionRef) {
      observer.observe(currentSectionRef);
    }

    return () => {
      if (currentSectionRef) {
        observer.unobserve(currentSectionRef);
      }
    };
  }, []);

  const handlePlay = () => {
    setIsPlaying(true);
  };

  return (
    <>
      <div className='about-us-section'>
        <h2 className='section-title'>About Starllife Group</h2>
        <div className='row-section about-us-row-section'>
          <div>
            <p>
              Based in Miami, Florida, Starlife Group is a pioneering force in
              real estate development, construction and investment. Its
              expertise spans residential and commercial sectors, as well as
              comprehensive asset management. Starlife Group is dedicated to
              transforming spaces and communities through strategic planning and
              innovative design and a forward-thinking approach.
            </p>
            <p>
              Since its founding, Starlife Group has evolved into a fully
              integrated real estate powerhouse, overseeing all aspects of
              development, sales, construction, lending and capital ventures.
              Its portfolio spans South Florida and Europe and includes
              large-scale multifamily projects, mixed-use developments, luxury
              spec homes, townhouses, and commercial properties.
            </p>
            <p>
              Starlife Group’s mission is to reshape urban landscapes with
              innovative real estate solutions that harmonize modern living with
              sustainability and community growth. Founded by visionary leaders
              Gevorg and Amran Shahbazyan, Starlife Group strives to be the most
              trusted partner in development, leveraging its expertise and
              global partnerships to deliver projects that inspire and enhance
              the quality of life for residents, investors, and stakeholders
              alike. Starlife Group aims to build lasting value through
              commitment, transparency, and world-class service.
            </p>
          </div>
        </div>
      </div>
      <div className='video-container' ref={sectionRef}>
        {isPlaying ? (
          <video
            src={
              'https://pub-49d97e77b0ae42d0a47ad8443433d0fb.r2.dev/about-us.mp4'
            }
            controls
            autoPlay
            loop
            className='video-player'
          />
        ) : (
          <div className='video-cover' onClick={handlePlay}>
            <img src={AboutUsCover} alt='Video Cover' className='cover-image' />
            <button className='play-button'>
              <IoMdPlay />
            </button>
          </div>
        )}
      </div>
    </>
  );
}
